interface Options {
  filters: MaybeRefOrGetter<PlannedDeliveryFilters>
}

export function usePlannedDeliveriesCount(options: Options) {
  const { filters } = options

  const counts = useLazyAsyncData<PlannedDeliveryCount>(
    'PlannedDeliveriesCount',
    async () => {
      const tabs = PlannedDeliveriesService.getCounts(toValue(filters))
      const autoClickerNames: AutoClickerName[] = ['AuthorizePrescribedMedication', 'PrescribeMedication']
      const autoclickerErrors = AutoClickerErrorService.getAutoClickerCount({ autoClickerNames, isResolved: false })

      return {
        ...await tabs,
        failed: await autoclickerErrors.catch(() => 0),
      }
    },
    {
      default: () => ({
        toCheck: 0,
        checkAgain: 0,
        checked: 0,
        readyToPrescribe: 0,
        prescribed: 0,
        shipped: 0,
        failed: 0,
      }) satisfies PlannedDeliveryCount,
    },
  )

  watch(filters, () => counts.refresh())

  return counts
}
